import { Alert } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Link, useRouteMatch } from 'react-router-dom'
import { generateFilterParam } from '@contexts/searchParamsContext/utils'
import { Operator, colors } from '@global/constants'
import { ROUTES, routeByParam } from 'routes'
import { t } from '@lingui/core/macro'
import { useSsoEnabled } from '@global/hooks/queries/useAuthHintQuery'

const useStyles = makeStyles(theme => ({
  alert: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}))

export function ErrorsList({ type, errors, value = undefined, fieldId = undefined }) {
  const match = useRouteMatch()
  const { id: datasetId } = match.params

  const ssoEnabled = useSsoEnabled()

  // if no errors, exit early
  if (!errors || !errors.length) {
    return null
  }

  const classes = useStyles()
  const ssoParams = !ssoEnabled ? { login: 'system' } : {}
  const filter = generateFilterParam({
    fieldId,
    operator: Operator.EQUALS,
    value,
  })

  return (
    <div>
      {errors.map((error, idx) => {
        const originalDatasetId = error.errorData?.originalDatasetId
        const isPageMatchingDatasetId = +datasetId === originalDatasetId

        return (
          <Alert
            className={classes.alert}
            key={`alert-error-${idx}`}
            variant="outlined"
            severity={type}
          >
            {error.defaultErrorMsg}
            {originalDatasetId && !isPageMatchingDatasetId ? (
              <div style={{ marginTop: 10 }}>
                {t`For more information,`}&nbsp;
                <Link
                  to={routeByParam({
                    url: ROUTES.DATASET_DATA,
                    params: { id: originalDatasetId },
                    urlParams: { ...ssoParams, filter },
                  })}
                  target="_blank"
                  style={{ textDecoration: 'underline', color: colors.blue.main }}
                >
                  {t`view dataset filtered by duplicate value.`}
                </Link>
              </div>
            ) : null}
          </Alert>
        )
      })}
    </div>
  )
}
